import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const FileUploadIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox='0 0 32 32'
      sx={{ height: '32px', width: '32px', fill: 'transparent', ...sx }}
      {...props}
    >
      <path
        d='M28 20V21.6C28 23.8402 28 24.9603 27.564 25.816C27.1805 26.5686 26.5686 27.1805 25.816 27.564C24.9603 28 23.8402 28 21.6 28H10.4C8.15979 28 7.03969 28 6.18404 27.564C5.43139 27.1805 4.81947 26.5686 4.43597 25.816C4 24.9603 4 23.8402 4 21.6V20M22.6667 10.6667L16 4M16 4L9.33333 10.6667M16 4V20'
        stroke={props.color === 'secondary' ? 'white' : '#0072CE'}
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </SvgIcon>
  );
};

export default FileUploadIcon;
